export const SEOConfig = {
  title: "Away / Digital Home Portals",
  description:
    "Away / Digital Home Portals is an interactive software platform that enhances the customer journey and shortens the delivery process for the homebuilder.",
  image: "/images/ogp.jpg",
};
